<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><router-link to="/" class="voltar"><img class="imgVoltar" :src="imgVoltar"></router-link>Criar Post</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>

                            <v-card-text style="padding:0 0 0 0; width:100%" id="tipoPublicacao"> 
                                <!--v-radio-group v-model="opt1"-->
                                <label class="v-label theme--light">Selecione o tipo de publicação:</label>
                                <v-select
                                    :items="tipo"
                                    item-value="value.ID"
                                    item-text="value.name"
                                    return-object
                                    v-model="tipoSelect"
                                    v-on:change="changeType"
                                ></v-select>
                                                                
                            </v-card-text>
           
                            <div v-if="tipoEscolhido == 1 || tipoEscolhido == 2">
                                <v-text-field browser-autocomplete="new-texto" name="texto" label="Digite o texto" type="text"
                                            v-model="texto" data-cy="joinEmailField" required>
                                </v-text-field>
                                <br />
                                <div v-if="tipoEscolhido == 1">
                                
                                    <label class="v-label theme--light">Imagem *</label>
                                    <!--input type="file" @change="onFileSelected" id="fileButton" /-->
                                    <!--progress value="0" max="100" id="uploader">0</progress>
                                    <br /><br /-->
                                    
                                    <!-- inicio - plugin compressor de imagem -->
                                    <image-compressor class="compressor" :done="getFiles" :scale="scale" :quality="quality" ref="compressor"></image-compressor>

                                    <div style="display:none" class="checkbox">
                                    <input type="checkbox" v-model="originalSize">
                                    <span>Responsive Image?</span>
                                    </div>

                                    <div style="display:none" class="input-group">
                                    <label>Image Scale</label>
                                    <input type="number" v-model="scale">
                                    </div>

                                    <div style="display:none" class="input-group">
                                    <label>Image Quality</label>
                                    <input type="number" v-model="quality">
                                    </div>

                                    <div class="image-info" v-if="img">
                                        <b>Before: </b>
                                        <span>{{ original.size }}</span>
                                        <span class="separator"> | </span>
                                        <b>After: </b>
                                        <span>{{ compressed.size }}</span>
                                    </div>

                                    <div style="display: none" class="text-center" v-if="img">
                                    <img v-if="img" src="" alt="" :style="{ maxWidth: originalSize ? '100%' : null }" :src="img">
                                    <a :href="img" class="button" target="_blank">Download</a>
                                    </div>
                                    <b v-if="img">Preview da imagem: </b>
                                    <div class="text-center imagem" v-if="img">
                                        <img v-if="img" src="" alt="" :src="img">
                                    </div>
                                    <!-- Fim - plugin compressor de imagem -->
                                </div>
                                <div v-if="tipoEscolhido == 2">
                                
                                    <!-- <label class="v-label theme--light">Vídeo: (embed do Youtube)</label> -->
                                    <v-text-field name="video" label="Vídeo(Link do Youtube) *" type="text"
                                            v-model="embed">
                                    </v-text-field>
                                    
                                </div>
                                <v-text-field name="textoLink" label="Texto do link" type="text"
                                            v-model="textoLink" required>
                                </v-text-field>
                                <v-text-field name="link" label="Link" type="text"
                                            v-model="link" required>
                                </v-text-field>
                            </div>
                            
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="criarPost" data-cy="joinSubmitBtn">Criar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogUpload" max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialogUpload = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';
import {mask} from 'vue-the-mask'
import { userProperties, cache } from '@/global.js'
import imageCompressor from 'vue-image-compressor' // https://vuejsfeed.com/blog/compress-image-files-with-vue-2-image-compressor

import imgVoltar from '../assets/ic-voltar.png';

export default {
    name: 'Criar-Post',
    directives: {mask},
    data() {
        return {
            imgVoltar: imgVoltar,
            valid: false,
            texto: null,
            textoLink: null,
            link: null,
            timestamp: null,
            dialog: false,
            loading: false,
            slug: null,
            extensao : null,
            statusUpload: true,
            tituloModal: "Post criado com sucesso!",

            // Dados do compressor de imagens - Inicio 
            dialogUpload: false,
            img: null,
            scale: 100,
            quality: 50,
            originalSize: true,
            original: {},
            compressed: {},
            tresVezes: 0,
            // Dados do compressor de imagens - Fim 
            tipo: [
                {
                    value: {
                        ID: 1,
                        name: 'Imagem'
                    },
                    text: 'Imagem'
                },
                {
                    value: {
                        ID: 2,
                        name: 'Vídeo'
                    },
                    text: 'Vídeo'
                }
            ],
            tipoSelect: {
                value: {
                    ID: 0,
                    name: 'Selecione'
                },
                text: 'Selecione'
            },
            tipoEscolhido: 0,
            embed: null
        };
    },
    components: { imageCompressor },
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        criarPost(){
            
            if(userProperties.escolaID != null){            
                this.loading = true
                // timestamp
                    var now = new Date();
                    var year = "" + now.getFullYear();
                    var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                    var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                    var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                    var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                    var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                    //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                    var customtimestamp = year + month + day + hour + minute + second
                    if(this.embed == null && this.img != null && this.tipoEscolhido == 1){ // SE FOR IMAGEM
                        db.collection('posts_' + userProperties.escolaID).add({
                            nome: userProperties.nome,
                            imagemPerfil: userProperties.imagem,
                            escolaID: userProperties.escolaID,
                            slugAutor: userProperties.slug,
                            
                            slug: this.slug,
                            customtimestamp: customtimestamp,
                            texto: this.texto,
                            textoLink: this.textoLink,
                            link: this.link,
                            extensao: this.extensao,
                            tipo: this.tipoEscolhido
                            
                        })
                        .then(docRef => {
                            console.log('Document written with ID: ', docRef.id);

                            // deixa o cache igual a false para atualizar posts da home
                            cache.home = false;

                            //this.$router.push(`/${slug}/success`)
                            this.loading = false
                            this.tituloModal = "Post criado com sucesso!"
                            this.dialog = true;
                            
                            // Log do sistema
                            if(userProperties.escolaID != null){            
                                // timestamp
                                var now = new Date();
                                var year = "" + now.getFullYear();
                                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                                var customtimestamp = year + month + day + hour + minute + second
                                db.collection('log_' + userProperties.escolaID).add({
                                        escolaID: userProperties.escolaID,
                                        slugAutor: userProperties.slug,
                                        perfil: userProperties.perfil,
                                        
                                        //slug: this.slug,
                                        customtimestamp: customtimestamp,
                                        dia: day,
                                        mes: month,
                                        ano: year,
                                        acao: "criar",
                                        categoria: "postagens",
                                        pontos: 0
                                        
                                    })
                                    .then(docRef => {
                                        console.log('Document written with ID: ', docRef.id);
                                        
                                    })
                                    .catch(function (error) {
                                        console.log('Error adding document: ', error);
                                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                                    })
                            }
                            else{
                                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                                this.$router.push(`/`);
                            }
                            
                        })
                        .catch(function (error) {
                            this.loading = false
                            console.log('Error adding document: ', error);
                            this.tituloModal = "Erro ao criar postagem. Tente novamente!"
                            this.dialog = true
                        })
                    }
                    if(this.embed != null && this.img == null && this.tipoEscolhido == 2){ // SE FOR VIDEO
                        db.collection('posts_' + userProperties.escolaID).add({
                            nome: userProperties.nome,
                            imagemPerfil: userProperties.imagem,
                            escolaID: userProperties.escolaID,
                            slugAutor: userProperties.slug,
                            
                            slug: this.slug,
                            customtimestamp: customtimestamp,
                            texto: this.texto,
                            textoLink: this.textoLink,
                            link: this.link,
                            extensao: this.extensao,
                            tipo: this.tipoEscolhido,
                            video: this.embed
                            
                        })
                        .then(docRef => {
                            console.log('Document written with ID: ', docRef.id);
                            //this.$router.push(`/${slug}/success`)
                            this.loading = false
                            this.tituloModal = "Post criado com sucesso!"
                            this.dialog = true

                            // Log do sistema
                            if(userProperties.escolaID != null){            
                                // timestamp
                                var now = new Date();
                                var year = "" + now.getFullYear();
                                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                                var customtimestamp = year + month + day + hour + minute + second
                                db.collection('log_' + userProperties.escolaID).add({
                                        escolaID: userProperties.escolaID,
                                        slugAutor: userProperties.slug,
                                        perfil: userProperties.perfil,
                                        
                                        //slug: this.slug,
                                        customtimestamp: customtimestamp,
                                        dia: day,
                                        mes: month,
                                        ano: year,
                                        acao: "criar",
                                        categoria: "postagens",
                                        pontos: 3
                                        
                                    })
                                    .then(docRef => {
                                        console.log('Document written with ID: ', docRef.id);
                                        
                                    })
                                    .catch(function (error) {
                                        console.log('Error adding document: ', error);
                                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                                    })
                            }
                            else{
                                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                                this.$router.push(`/`);
                            }
                            
                        })
                        .catch(function (error) {
                            this.loading = false
                            console.log('Error adding document: ', error);
                            this.tituloModal = "Erro ao criar postagem. Tente novamente!"
                            this.dialog = true
                        })
                    }
                    if(this.embed == null && this.img == null){
                        alert("Preencha os campos obrigatórios!")
                        this.loading = false
                    }
                
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
            
        },
        changeType(type){
            this.img = null
            this.embed = null
            this.tipoEscolhido = type.value.ID;
        },
        closeModal(){
            //this.loading = true;
            this.$router.push(`/`);
            location.reload();
            //window.location.href = "https://www.inclass.app";
        },        
        submit() {
            if (this.$refs.form.validate() && this.statusUpload == true) {
            }
            if (this.$refs.form.validate() && this.statusUpload == false) {
                alert("Por favor, faça o upload da foto do perfil do usuário")
            } 
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        // onFileSelected(event){
            
        //     this.loading = true;
        //     console.log(event);
        //     var file = event.target.files[0]
        //     var filename = event.target.files[0].name
            
        //     // Recupera imagem do storage
        //     var storageRef = firebase.storage().ref('postagens/'+this.slug+"."+filename.toString().split(".")[1])
        //     this.extensao = filename.toString().split(".")[1];
        //     var task = storageRef.put(file)
        //     var that = this;
        //     task.on('state_changed',
        //         function progress(snapshot){
        //             var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        //             uploader.value = percentage;
        //             that.loading = false;
        //         },
        //         function error(err){
        //             alert("Error on upload. Check if image size is less than 900KB");
        //             that.statusUpload = false;
        //             that.loading = false;
        //         },
        //         function complete(){
        //             that.extensao = filename.toString().split(".")[1];
        //             that.statusUpload = true;
        //             alert("Upload successful!");
        //             that.loading = false;
        //         }
        //     )
        // },
        upload () {
            let compressor = this.$refs.compressor.$el
            compressor.click()
        },
        changeRoute(a) {
            //this.$router.push({path: a.src })
            console.log(a);
            alert("Teste select tipo de publicação");
        },
        getFiles(obj){
            this.tresVezes = this.tresVezes + 1; // gambiarra do bug de executar 3 vezes
            

            this.img = obj.compressed.blob
            this.original = obj.original
            this.compressed = obj.compressed
            var escala = 0;
            var qualidade = 0;

            if(Number(obj.original.size.split(" ")[0]) > 4000){
                escala = 40;
                qualidade = 60;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 3000 && Number(obj.original.size.split(" ")[0]) <= 4000){
                escala = 55;
                qualidade = 60;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 2000 && Number(obj.original.size.split(" ")[0]) <= 3000){
                escala = 70;
                qualidade = 70;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 1000 && Number(obj.original.size.split(" ")[0]) <= 2000){
                escala = 80;
                qualidade = 70;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 500 && Number(obj.original.size.split(" ")[0]) <= 1000){
                escala = 90;
                qualidade = 80;
            }
            else{
                escala = 100;
                qualidade = 90;
            }

            this.scale = escala;
            this.quality = qualidade;
            //console.log(obj);
            this.loading = true;
            //console.log(event);
            if(this.tresVezes >= 2){
                this.tresVezes = 0;
                
                
                var file = obj.compressed.file

                var imageURL = obj.compressed.blob;
                
                var metadata = { contentType: 'image/jpeg'};
                //var metadata = { contentType: obj.original.type};
                var getFileBlob = function (url, cb) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", url);
                    xhr.responseType = "blob";
                    xhr.addEventListener('load', function() {
                        cb(xhr.response);
                    });
                    xhr.send();
                };
                //var uploadToStorage = (imageURL) => {

                    getFileBlob(imageURL, blob =>{
                        var filename = obj.compressed.file.name;
                        this.extensao = filename.toString().split(".")[1];
                        //this.scale = 40
                        
                        firebase.storage().ref().child('postagens/'+this.slug+"."+filename.toString().split(".")[1]).put(blob, metadata)
                            .then(snapshot => {
                                this.loading = false
                                this.dialogUpload = true
                                this.tituloModal = "Upload da imagem realizado com sucesso!"
                                
                            })
                            .catch( (error) => {
                                this.loading = false
                                this.dialogUpload = true
                                this.tituloModal = "Erro ao realizar upload da imagem. Tente novamente!"
                            })
                    })
                //}
                
                // var filename = obj.compressed.file.name
                
                // // Recupera imagem do storage
                // var storageRef = firebase.storage().ref().child('postagens/'+this.slug+"."+filename.toString().split(".")[1])
                // this.extensao = filename.toString().split(".")[1];
                // var task = storageRef.put(file)
                // var that = this;
                // task.on('state_changed',
                //     function progress(snapshot){
                //         var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                //         uploader.value = percentage;
                //         that.loading = false;
                //     },
                //     function error(err){
                //         alert("Error on upload. Check if image size is less than 900KB");
                //         that.statusUpload = false;
                //         that.loading = false;
                //     },
                //     function complete(){
                //         that.extensao = filename.toString().split(".")[1];
                //         that.statusUpload = true;
                //         alert("Upload successful!");
                //         that.loading = false;
                //     }
                // )
            }
            
            
      }
        
    },
    mounted() {
        const slug = this.generateUUID()
        this.slug = slug;
        // se perfil não for escola ou administrador
        if(userProperties.perfil == 1 || userProperties.perfil == 5 || userProperties.perfil == 6 || userProperties.perfil == 7){
            alert("Acesso negado!");
            this.$router.push(`/?redirect=`+window.location.pathname)
        }        
    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }
    .btCirculo{
        height: 30px;
        width: 30px;
    }
    .btCirculo a{
        color:#fff;
    }
    progress{
        width:100%;
        margin-top: 6px;
    }
    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }
    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }
    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }
    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }
    .container{
        padding: 0 0 !important;
    }

    .imagem img{
        width: 100%;
        margin-top: 8px;
    }
    
</style>